import { useFx } from "@/context/FxContext";
import { useAuth } from "@/context/AuthContext";
import { CURRENCIES, formatMoney } from "@/lib/currency";

/* Hook that returns a `(amount) => string` formatter and the active display currency,
   optionally overridden by a UI control. Always converts from the user's base currency
   (the one all stored amounts are denominated in) to the chosen display currency.
*/
export function useDisplayMoney(displayCurrency) {
  const { user } = useAuth();
  const { convert } = useFx();
  const base = user?.currency || "USD";
  const display = displayCurrency || base;
  return {
    base,
    display,
    fmt: (amount) => formatMoney(convert(amount, base, display), display),
    fmtCompact: (amount) => formatMoney(convert(amount, base, display), display, { compact: true }),
  };
}

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function CurrencyToggle({ value, onChange }) {
  const { user } = useAuth();
  const base = user?.currency || "USD";
  return (
    <div className="inline-flex items-center gap-2" data-testid="currency-toggle">
      <span className="text-xs uppercase tracking-widest text-muted-foreground">Show in</span>
      <Select value={value || base} onValueChange={onChange}>
        <SelectTrigger className="h-8 w-[110px] rounded-full" data-testid="currency-toggle-trigger"><SelectValue /></SelectTrigger>
        <SelectContent>
          {CURRENCIES.map((c) => (
            <SelectItem key={c.code} value={c.code}>{c.symbol} {c.code}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
